/* before-after.js — draggable before/after comparison slider.
   Vanilla Pointer Events (mouse + touch + pen).
   Container has touch-action: pan-y so vertical swipes still scroll
   the page (a vertical pan fires pointercancel and ends the drag);
   the handle itself has touch-action: none so it always drags. */
(function () {
  'use strict';

  function initSlider(container) {
    var before = container.querySelector('[data-ba-before]');
    var line = container.querySelector('[data-ba-line]');
    var handle = container.querySelector('[data-ba-handle]');
    if (!before || !line || !handle) return;

    var dragging = false;

    function setPosition(percentage) {
      percentage = Math.max(0, Math.min(100, percentage));
      before.style.clipPath = 'inset(0 ' + (100 - percentage) + '% 0 0)';
      line.style.left = percentage + '%';
      handle.style.left = percentage + '%';
    }

    function percentFromEvent(e) {
      var rect = container.getBoundingClientRect();
      if (!rect.width) return 50;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      handle.classList.add('dragging');
      setPosition(percentFromEvent(e));
      try {
        container.setPointerCapture(e.pointerId);
      } catch (err) {
        /* capture unsupported — drag still works within the container */
      }
      if (e.pointerType === 'mouse') e.preventDefault();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      setPosition(percentFromEvent(e));
    }

    function onPointerEnd() {
      if (!dragging) return;
      dragging = false;
      handle.classList.remove('dragging');
    }

    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup', onPointerEnd);
    container.addEventListener('pointercancel', onPointerEnd);

    /* Click / tap anywhere on the image jumps the slider there
       (parity with the original theme behavior). */
    container.addEventListener('click', function (e) {
      setPosition(percentFromEvent(e));
    });

    /* Initialize at 50% */
    setPosition(50);
  }

  function init() {
    var sliders = document.querySelectorAll('.before-after-section [data-ba-slider]');
    if (!sliders.length) return;
    for (var i = 0; i < sliders.length; i++) {
      initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
